/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {Fragment} from 'react';
import {Col, FormControl, Row} from "react-bootstrap";
import {
    useUpdateTableFilters
} from "../../../../../Hooks/TableHooks";

export const SpeciesListTableFilter = (props) => {
    const {
        UpdateFilters: updateFilters = null,
        filterValues,
        setFilterValue
    } = props;

    const {
        textFilter = ''
    } = filterValues;

    const textFilterUppercase = textFilter?.toUpperCase?.();

    const filters = [
        {
            code: 'textFilter',
            isSet: textFilterUppercase !== "",
            logic:  x => x.name.toUpperCase().includes(textFilterUppercase)
        }
    ];

    useUpdateTableFilters(filters, updateFilters, [textFilter]);

    return <Fragment>
        <Col md={6} sm={12} xs={12}/>
        <Col md={6} sm={12} xs={12}>
            <Row className="justify-content-end">
                <Col xs={6} className="d-flex align-items-center">
                    <FormControl
                        type="text"
                        value={textFilter || ""}
                        placeholder="Search"
                        onChange={event => setFilterValue('textFilter', event.target.value)}
                    />
                </Col>
            </Row>
        </Col>
    </Fragment>;
};
